<template lang="pug">
.set.data.left(:class="{'new-item': isNew}")
  .data-general-information(@click="expand = !expand")
    .item-list.set-bug
      .data-number-list(:class="{hidden: isNew}") {{ isNew ? 0 : index + 1 }}
      .data-information-list.set
        .data-image
          img.data-description-list-image-x(v-if="data.images && data.images[0]" :src="`${imagePath}/${data.brand}/products/sets/${data.images[0]}`" :alt="data.id")
        div
          .data-description-list
            span.dark Id:
            span {{ data.id }}
          .data-description-list
            span.dark Marca:
            span.capitalize {{ data.brand }}
          .data-description-list
            span.dark Imagen:
            span {{ data.images[0] }}
          .data-description-list
            span.dark Productos:
            span {{ arrayToString(data.products) }}

  transition.user-details-information(name="slide-fade")
    shForm.list(v-if="expand && !history" :dataOriginal="data" :fillData="true")
</template>

<script>
import shForm from './Form'
import shExpandButton from '@/components/elements/ExpandButton'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Set',

  mixins: [mFilters, mForm],

  components: { shForm, shExpandButton },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      checked: false,
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  }
}
</script>

<style lang="stylus">
.item-list.set-bug
  transform scale(1)

.data-description-list-image-x
  height 13em

.data-information-list.set
  display inline-flex
  gap 1em
  align-items center
</style>



// WEBPACK FOOTER //
// src/components/pages/set/Set.vue